import { StableBond, LPBond, NetworkID, CustomBond, BondType } from "src/lib/Bond";

import { ReactComponent as DaiImg } from "src/assets/tokens/DAI.svg";
import { ReactComponent as UsdcImg } from "src/assets/tokens/USDC.svg";
import { ReactComponent as GwsDaiImg } from "src/assets/tokens/GWS-DAI.svg";
import { abi as BondGwsDaiContract } from "src/abi/bonds/GwsDaiContract.json";
import { abi as DaiBondContract } from "src/abi/bonds/DaiContract.json";
import { abi as UsdcBondContract } from "src/abi/bonds/UsdcContract.json";
import { abi as ReserveGwsDaiContract } from "src/abi/reserves/GwsDai.json";
import { abi as ReserveDaiContract } from "src/abi/reserves/Dai.json";
import { abi as ReserveUsdcEthContract } from "src/abi/reserves/UsdcEth.json";

export const usdc_eth = new LPBond({
  name: "usdc_eth_lp",
  displayName: "USDC-ETH LP",
  bondToken: "USDC-ETH",
  isAvailable: { [NetworkID.Mainnet]: true, [NetworkID.Testnet]: false },
  bondIconSvg: GwsDaiImg,
  bondContractABI: BondGwsDaiContract,
  reserveContract: ReserveUsdcEthContract,
  networkAddrs: {
    [NetworkID.Mainnet]: {
      bondAddress: "0x0000000000000000000000000000000000000000",
      reserveAddress: "0x397FF1542f962076d0BFE58eA045FfA2d347ACa0",
    },
    [NetworkID.Testnet]: {
      bondAddress: "0x0000000000000000000000000000000000000000",
      reserveAddress: "0xc20cf81dfF14ce8C9b454e6Cd4B2145d81535849",
    },
  },
  lpUrl: "",
});

export const gws_dai = new CustomBond({
  name: "gws_dai_lp",
  displayName: "GWS-DAI LP",
  bondToken: "GWS-DAI",
  isAvailable: { [NetworkID.Mainnet]: false, [NetworkID.Testnet]: false },
  bondIconSvg: GwsDaiImg,
  bondContractABI: BondGwsDaiContract,
  reserveContract: ReserveGwsDaiContract,
  bondType: BondType.LP,
  lpUrl: "",
  networkAddrs: {
    [NetworkID.Mainnet]: {
      bondAddress: "0x96b2A9C51e3364195F133c8B34FDADCD21Ca59eC",
      reserveAddress: "0x5669Deb8CC857661e64Fe08F41Bd74536758818E",
    },
    [NetworkID.Testnet]: {
      bondAddress: "",
      reserveAddress: "",
    },
  },
  customTreasuryBalanceFunc: async function (this: CustomBond, networkID, provider) {
    return 0;
  }
});

export const gws_dai_v3 = new CustomBond({
  name: "gws_dai_lp_V3",
  displayName: "GWS-DAI V3 LP",
  bondToken: "GWS-DAI",
  isAvailable: { [NetworkID.Mainnet]: false, [NetworkID.Testnet]: false },
  bondIconSvg: GwsDaiImg,
  bondContractABI: BondGwsDaiContract,
  reserveContract: ReserveGwsDaiContract,
  bondType: BondType.LP,
  lpUrl: "",
  networkAddrs: {
    [NetworkID.Mainnet]: {
      bondAddress: "0x15eE1208802af6c2a1D004c72003b1533664443D",
      reserveAddress: "0x5669Deb8CC857661e64Fe08F41Bd74536758818E",
    },
    [NetworkID.Testnet]: {
      bondAddress: "",
      reserveAddress: "",
    },
  },
  customTreasuryBalanceFunc: async function (this: CustomBond, networkID, provider) {
    return 0;
  }
});

export const gws_dai_v4 = new LPBond({
  name: "gws_dai_lp_v4",
  displayName: "GWS-DAI V4 LP",
  bondToken: "GWS-DAI",
  isAvailable: { [NetworkID.Mainnet]: true, [NetworkID.Testnet]: false },
  bondIconSvg: GwsDaiImg,
  bondContractABI: BondGwsDaiContract,
  reserveContract: ReserveGwsDaiContract,
  networkAddrs: {
    [NetworkID.Mainnet]: {
      bondAddress: "0xaA0D8f08c2a5a8431d46c3039e6900E5e6599D5e",
      reserveAddress: "0x5669Deb8CC857661e64Fe08F41Bd74536758818E",
    },
    [NetworkID.Testnet]: {
      bondAddress: "",
      reserveAddress: "",
    },
  },
  lpUrl: "https://app.uniswap.org/#/add/v2/0x36F17BD0F7028c784b2e0C9B5a65dBe071a902d7/0x6B175474E89094C44Da98b954EedeAC495271d0F",
});

export const daiv2 = new CustomBond({
  name: "daiv2",
  displayName: "DAI V2",
  bondToken: "DAI V2",
  bondIconSvg: DaiImg,
  bondContractABI: DaiBondContract,
  reserveContract: ReserveDaiContract,
  isAvailable: { [NetworkID.Mainnet]: false, [NetworkID.Testnet]: false },
  bondType: BondType.StableAsset,
  lpUrl: '',
  networkAddrs: {
    [NetworkID.Mainnet]: {
      bondAddress: "0x5bf0f435fD138b307Ad36fF89E582154B8F7B89d",
      reserveAddress: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    },
    [NetworkID.Testnet]: {
      bondAddress: "",
      reserveAddress: "",
    },
  },
  customTreasuryBalanceFunc: async function (this: CustomBond, networkID, provider) {
    return 0;
  }
});

export const daiv3 = new CustomBond({
  name: "daiv3",
  displayName: "DAI V3",
  bondToken: "DAI V3",
  bondIconSvg: DaiImg,
  bondContractABI: DaiBondContract,
  reserveContract: ReserveDaiContract,
  isAvailable: { [NetworkID.Mainnet]: false, [NetworkID.Testnet]: false },
  bondType: BondType.StableAsset,
  lpUrl: '',
  networkAddrs: {
    [NetworkID.Mainnet]: {
      bondAddress: "0x581158433D4CD805dcc89EA2EA63917611655198",
      reserveAddress: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    },
    [NetworkID.Testnet]: {
      bondAddress: "",
      reserveAddress: "",
    },
  },
  customTreasuryBalanceFunc: async function (this: CustomBond, networkID, provider) {
    return 0;
  }
});

export const daiv4 = new StableBond({
  name: "daiv4",
  displayName: "DAI V4",
  bondToken: "DAI V4",
  bondIconSvg: DaiImg,
  bondContractABI: DaiBondContract,
  isAvailable: { [NetworkID.Mainnet]: true, [NetworkID.Testnet]: false },
  networkAddrs: {
    [NetworkID.Mainnet]: {
      bondAddress: "0x01893DAfC8fb232B86401F1143F3B81591238BEd",
      reserveAddress: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    },
    [NetworkID.Testnet]: {
      bondAddress: "",
      reserveAddress: "",
    },
  },
});

// HOW TO ADD A NEW BOND:
// Is it a stableCoin bond? use `new StableBond`
// Is it an LP Bond? use `new LPBond`
// Add new bonds to this array!!
// export const allBonds = [dai, gws_dai, gws_weth];
export const allBonds = [daiv2, daiv3, daiv4, gws_dai, gws_dai_v3, gws_dai_v4];
export const allBondsMap = allBonds.reduce((prevVal, bond) => {
  return { ...prevVal, [bond.name]: bond };
}, {});

// Debug Log
// console.log(allBondsMap);
export default allBonds;
